export default {
  loading: false,
  payments: [],
  payment: {}
}
